export default "* Selvhærdende ler fx i farven terrakotta eller sort\n* Vand \n* Evt. små tynde pinde eller trægrillspyd \n* Evt. mat lak eller akrylmaling \n";